export default __webpack_public_path__ + "static/logo-33526e1a5d57487fa35b6957d21d1a8d.svg";